import { createReducer } from "@reduxjs/toolkit";
import { TYPES } from "../../common/constants";

const addFilterQuery = (serviceRequest, { payload }) => {
  return {
    ...payload,
  };
};

const clearFilterRequestDone = () => {
  return initialState;
};

const initialState = {
  walkthrough: [],
  startDate: "",
  endDate: "",
  project: "",
  issueType: "",
  assetType: "",
  building: "",
  level: "",
  assignTo:"",
  commonAreas:"",
};

export default createReducer(initialState, {
  [TYPES.CLEAR_FILTER_REQUEST]: clearFilterRequestDone,
  [TYPES.ADD_FILTER_QUERY]: addFilterQuery,
});
